import { RegularHistoryLifeSupportPage } from "@/features/regular-document/pages/life-support-document/RegularHistoryLifeSupport";

const RegularHistoryLifeSupport = () => {
  return <RegularHistoryLifeSupportPage />;
};

export default RegularHistoryLifeSupport;
